module.exports = __webpack_public_path__ + "static/img/Luke-Parker.d516e6c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Luke-Parker.jpg
// module id = JS64
// module chunks = 0